import { SyntheticEvent } from "react"
import { ResponseArray, ResponseObject } from "../../common/common.entity"
import { APICallFunction } from "../../pages/userMangement/role/apiCall"
import { GridProps } from "@mui/material"
import { NavigateFunction, Path, To } from "react-router-dom"

export enum ValueTypes {
    number = 'number',
    noSpace = 'noSpace',
    onlyAlphabets = 'onlyString',
    bothStringNumber = 'bothStringNumber',
    allCharacter = 'allCharacter',
    decimalNumber = 'decimalNumber',
    checkbox = 'checkbox',
    email = 'email',
    countryCode = 'countryCode',
    mobile = 'mobile',
    urlPath = 'urlPath',
    password = 'password',
    confirmPassword = 'confirmPassword'
}

export const ErrorText: Record<string, string> = {
    required: 'This field is required',
    invalid: 'Invalid Input',
    date: 'Please select valid date',
    [ValueTypes.number]: 'Please enter only numbers',
    [ValueTypes.decimalNumber]: 'Please enter only decimal numbers',
    [ValueTypes.onlyAlphabets]: 'number is not allowed',
    [ValueTypes.bothStringNumber]: 'special charachters not allowed',
    [ValueTypes.email]: 'Please enter valid email',
    [ValueTypes.mobile]: 'Please enter valid mobile number',
    [ValueTypes.countryCode]: 'Please enter valide country code',
    [ValueTypes.noSpace]: 'Space is not allowed',
    [ValueTypes.urlPath]: `Please enter a valid path matching pattern '/path?query=search'`,
    [ValueTypes.password]: `The password should be at least 8 characters long, should contain at least one uppercase letter, one lowercase letter, one number and one special character.`,
    [ValueTypes.confirmPassword]: 'Password should match Confirm Password'
}

export enum FormItemTypes {
    SearchSelect = 'SearchSelect',
    TextInput = 'TextInput',
    NumberInput = "NumberInput",
    DatePicker = 'DatePicker',
    TimeZonePicker = 'TimeZonePicker',
    CheckBox = 'CheckBox',
    Logo = 'Logo',
    Card = "Card",
    Container = "Container",
    Accordian = "Accordian",
    Custom = "Custom",
    Password = "Password",
    TreeList = 'TreeList'
}

export interface IFormData extends Record<string, any> {
    type: FormItemTypes
    name: string
    label?: string
    value?: any
    valueTypes?: ValueTypes
    required?: boolean
    disabled?: boolean
    options?: ResponseArray
    APICall?: APICallFunction
    displayExpr?: string
    valueExpr?: string
    loading?: boolean
    itemSize?: GridProps['size']
}

export interface IFormBuilder {
    createKey?: string
    createRequest?: ResponseObject
    createFormAPI?: APICallFunction

    updateKey?: string
    updateRequest?: ResponseObject
    updateFormAPI?: APICallFunction

    getKey?: string
    getRequest?: ResponseObject
    getFormAPI?: APICallFunction

    formData: (IFormData | null)[]
    mode?: 'add' | 'edit' | 'view' | string
    parentPath?: To
    headerLabel?: string
    isHeader?: boolean
    isRightMenu?: boolean
    isheaderLabel?: boolean
    isTitle?: boolean

    onClose?: (e?: SyntheticEvent, isUpdated?: boolean) => void
    onSubmit?: (data: Partial<ResponseObject>) => Partial<ResponseObject>
    disableAPICalls?: boolean
    pagingAPIKey?: string

    setFieldProps?: (currValue: any, state: ResponseObject, field: IFormData) => Partial<IFormData> | Promise<Partial<IFormData>> | void
}

export interface FormElementOverrideProps {
    formLoop: (el: (IFormData | null)) => React.ReactNode
    onChange: (event: any, value?: any, reason?: string) => any
    onInputChange: (e: any, value?: any) => any
    onImageChange: (e: any, key?: any) => any
    error: string
    src: string
}

export type FormElementProps = IFormData & Partial<FormElementOverrideProps>
export type FormItemComponent = (props: FormElementProps) => React.ReactElement